import Const from "../constants/Constants";
var $ = window.$ || {};

class Util{

  static getOnscreenCount = () => {
      let len = $('#hostParticipantStreamsList .participantStreamPart').length;
      let count = 0;

      if (len > 0) {
          $('#hostParticipantStreamsList .participantStreamPart').each(function (index, value) {
              if ($(this).hasClass('d-none') === false) {
                  count++;
              }
          });
      }

      return count;
  }

  static getCurrentTimestamp = () => {
      return new Date().getTime();
  }

  static checkTime = (timeDur) => {
      let time = 0;
      let sec = Math.floor(timeDur / 1000);

      if(sec > 60) {
          let min = Math.floor(sec / 60);

          if(min > 60){
              let hrs =  Math.floor(min / 60);
              time = hrs + ' hrs '
          } else {
              time = min + ' min '
          }
      } else {
          time = sec + ' sec '
      }

      return time;
  }

  static switchVideoSize = () => {
      let len = Util.getOnscreenCount();

      if(len == 0) return false;

      let vdoSize = '';
      if(len == 1){
        vdoSize = 'one mx-auto';
      } else if(len == 2) {
        vdoSize = 'two';
      } else if(len == 3) {
        vdoSize = 'three';
      } else if(len == 4) {
        vdoSize = 'four';
      } else {
        vdoSize = 'five';
      }

      $('#subscribers-list .newcss').each(function (index, value) {
          $(this).removeClass('col-md-6 col-md-4 one two three four five ol-lg-8 col-md-4 col-lg-6 col-lg-5 col-lg-4 col-lg-3 col-sm-6 col-sm-4 col-sm-3 col-6 col-12 mx-auto');
          $(this).addClass(vdoSize);
      });
  }

  static onPageResize = () => {

      let leftHeight = $(".right-sidebar").height();    

      let winHeight = $( window ).height();
      let headerHeight = $(".header.bg-gray").height();
      let hostHeight = $(".host-script-section").height();
      let sectionHeights = winHeight - (hostHeight + headerHeight);

   
      if ($(window).width() > 1500) {
        $(".script-info .carousel-inner.guest-left-wine").css("max-height", `${winHeight - 450}px`);
      } else{
        $(".script-info .carousel-inner.guest-left-wine").css("max-height", `${winHeight - 290}px`);
      }

      $("#subscribers-list").height(`${sectionHeights - 94}px`);
      $(".section.attendees").css("margin-top", `${headerHeight+21}px`);
    
      let sub_list_y = $("#subscribers-list").height(); 
      let sub_list_x = $("#subscribers-list").width();
      let len_subs = Util.getOnscreenCount();
      if($(".show-hide-title").hasClass("d-none")){
          $(".section.attendees").addClass("mt-76");      
      } else {
          $(".section.attendees").removeClass("mt-76");        
      }
    
      if(sub_list_x <= 992){
        if(len_subs>2) {
          $("#subscribers-list")
          .addClass("display-grid-auto-2");
        }
      } else {
        if(len_subs>4) {
          $("#subscribers-list")
          .addClass("display-grid-auto-4");
        }
      }

      setTimeout(function(){

        let newHt = sub_list_y;
        if(sub_list_x <= 992){
          if(len_subs > 2) {
            
            let rem = len_subs % 2;

            // get num of rows of vdos
            let numVdoRw = parseInt(len_subs / 2) + ( rem == 0 ? 0 : 1 );

            newHt = sub_list_y / numVdoRw;
          }
        } else {
          if(len_subs > 4) {
            newHt = sub_list_y / 2;
          }
        }

        let newWt = newHt * 1.778;
        
        if(sub_list_x <= 992){

          if(len_subs >= 2 ){

            if(len_subs>2)
              len_subs = 2;

            if(newWt * len_subs > sub_list_x) {
              let tmpWt = newWt * len_subs - sub_list_x;
              tmpWt = tmpWt / len_subs;
              newWt = newWt - tmpWt;
              newHt = newWt / 1.778; 
            }
          }

        } else {

          if(len_subs >= 2 ){

            if(len_subs>4)
              len_subs = 4

            if(newWt * len_subs > sub_list_x) {
              let tmpWt = newWt * len_subs - sub_list_x;
              tmpWt = tmpWt / len_subs;
              newWt = newWt - tmpWt;
              newHt = newWt / 1.778; 
            }
          }
        }
		
        $(".newcss.one, .newcss.two, .newcss.three, .newcss.four, .newcss.five").height(`${newHt - 5 }px`);
        $(".newcss.one, .newcss.two, .newcss.three, .newcss.four, .newcss.five").width(`${newWt - 5 }px`);
        
		
		let aspectRatio2 = 9/16;
		
		let heightNum = newHt - 5 * aspectRatio2;
		$(".newcss").css({'max-height' : heightNum +'px'});
		
     }, 100);
  }

  static createDropdown = (userlength, maxlimit, selectedOption) => {
	  console.log('createDropdown--------------------');
      let loopCount = userlength > maxlimit ? maxlimit : userlength;
      $('#maxuserlimit').html('');
      for(let i = loopCount; i > 0; i--) {
        $('#maxuserlimit')
           .append($("<option></option>")
                      .attr("value", i)
                      .text(i));
	  }

      if (selectedOption !== null) {
		  console.log('null ',selectedOption);
          $('#maxuserlimit option[value="'+selectedOption+'"]').attr("selected", "selected");
		  window['onScreenUsers'](userlength);
      }
  }

  static getStreamOrder = () => {
      let order = 1;
      let orderArray = [];

      $('#subscribers-list .newcss').each(function (index, value) {
          orderArray.push(parseInt($(this).css("order")));
		 
	  });

      if (orderArray.length > 0) {
          order = Math.max.apply(Math, orderArray) + 1;
      }
      return order;
  }

  static getSessionData = () => {
      return localStorage.getItem("sessionData") !== null ? JSON.parse(localStorage.getItem("sessionData")) : [];
  }

  static setSessionData = (sessionData) => {
      localStorage.setItem('sessionData', JSON.stringify(sessionData));
  }

  static getCurrentUserData = () => {
      return JSON.parse(localStorage.getItem("userData"));
  }

  static getLocalStatsValue = (accessDelay) => {
      if (accessDelay <= 50) {
          return 5;
      } else if (accessDelay <= 100) {
          return 4;
      } else if (accessDelay <= 150) {
          return 3;
      } else if (accessDelay <= 200) {
          return 2;
      }

      return 1;
  }

  static getSessionEndTime = (userData) => {
      let sessionStartTime  = userData.sessionData.scheduleDate;
      let sessionEndTime    = new Date(sessionStartTime);
      sessionEndTime.setMinutes(sessionEndTime.getMinutes() + userData.sessionData.duration);

      return sessionEndTime;
  }

  static forceLogout = () => {
      Util.removeSession();
	    window.location.href  = window['electron'] ? 'index.html' : '/login';
  }

  static removeSession = () => {
      localStorage.removeItem("userData");
      //localStorage.removeItem("media-setting");
      localStorage.removeItem("tempUsers");
      localStorage.removeItem("video-resolution");
      localStorage.removeItem("hostStreamMuted");
      localStorage.removeItem("unmuteAll");
      localStorage.removeItem("sessionList");
      localStorage.removeItem("recordingStarted");
  }

  static getFirstUppercase = (str) => {
      str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });

      return str;
  }

  static getUTCTimestamp = () => {
      var now = new Date();
      now.toUTCString();
      return Math.round(now.getTime()/ 1000);
  }

  static convertSecondsToTime = (seconds) => {
      var hrs = ~~(seconds / 3600);
      var mins = ~~((seconds % 3600) / 60);
      var secs = ~~seconds % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";
      if (hrs > 0) {
          ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }
      ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      ret += "" + secs;

      return ret;
  }

  static popupateHostResolution = (settings)=>{
    var profile = window.electron ? settings.nativeHostVideoProfile : settings.hostVideoProfile;
        
    var hostSettings = JSON.parse(profile);
    hostSettings.forEach((item)=>{
      Const.HOST_RESOLUTION[item.type] = item.res;
    })
  
  }

  static popupateParticipapntResolution = (settings) => {
    var profile = window.electron ? settings.nativeParticipantVideoProfile : settings.participantVideoProfile;
        
    var participantSettings = JSON.parse(profile);
    participantSettings.forEach((item)=>{
      Const.PARTICIPANT_RESOLUTION[item.type] = item.res;
    })
  
  }

  static generateRandomNumber = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  static getUTCTimestamp = () => {
      var now = new Date();
      now.toUTCString();
      return Math.round(now.getTime()/ 1000);
  }

  static checkUpcomingSession = (sessionData, joinDuration) => {
      let overlapping = false;

      console.log('upcoming sessions - ', sessionData);

      let sortedSessionData = sessionData.sort(Util.sortByDate);

      sortedSessionData.forEach( (session) => {
          let timeDiff = Util.diff_minutes(new Date(session.scheduleDate));

          if ( timeDiff <= joinDuration ) 
          {
              overlapping = true;
          }
      });

      return overlapping;
  }

  static sortByDate = (a, b) => {
    return ((a.scheduleDate < b.scheduleDate) ? -1 : ((a.scheduleDate > b.scheduleDate) ? 1 : 0));
  }

  static diff_minutes = (sessionDate) => {
    var diff = (sessionDate.getTime() - new Date().getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));  
  }

  static time_convert = (num) => {
    let ext = num >= 60 ? 'Hr' : 'Min';
    var hours = Math.floor(num / 60);  
    var minutes = num % 60;
    return hours + ":" + minutes + ' ' + ext;
  }

  static showChannelLink = (userData, counter) => {
      if (userData.showNextPast == 'next' || 
          userData.showNextPast == 'past' || 
          ( userData.showNextPast == 'join' && [0].indexOf(counter) == -1) ||
          ( userData.showNextPast == 'overlap' && [0,1].indexOf(counter) == -1) 
        ) 
      {
          return true;
      }

      return false;
  }

  static showJoinButton = (userData, counter) => {
      if ( ( userData.showNextPast == 'join' && [0].indexOf(counter) != -1) ||
           ( userData.showNextPast == 'overlap' && [0,1].indexOf(counter) != -1) 
        ) 
      {
          return true;
      }

      return false;
  }

  static getActivityName = (activity_name, maxlimit) => {

      if ( activity_name.length > maxlimit )
      {
          return activity_name.substring(0, maxlimit-1) + '...';
      }

      return activity_name;
  }

  static getScriptLength = (userData) => {

      let count = 0;

      if ( userData === null || userData.sessionData.scriptDetail == undefined ) { return; }

      if (userData.onDemand != undefined && userData.onDemand == 1)
      {
          userData.sessionData.scriptDetail.forEach( (scriptData) => {
              scriptData.attribute.forEach( (scriptAttr) => {
                  if ( scriptAttr.attrLabel == 'Activity Type' )
                  {
                      count++;
                  }
              });
          });
      }
      else
      {
          userData.sessionData.scriptDetail.forEach( (scriptData) => {
              scriptData.attribute.forEach( (scriptAttr) => {
                  if ( scriptAttr.attrLabel == 'Activity Type' )
                  {
                      count++;
                  }
              });
          });
      }

      return count;
  }

  static networkQualityMapping = (networkQuality) => {
      if (networkQuality == 1 || networkQuality == 0) {
          return 5;
      } else if (networkQuality == 2) {
          return 4;
      } else if (networkQuality == 3) {
          return 3;
      } else if (networkQuality == 4) {
          return 2;
      }

      return 1;
  }

  static appendUserPalette = (userId) => {
      $('.paletteFlex').append('<div id="movedEquipment" class="equipmentTagsHolder d-none">Set up equipment</div>'+
	  '<div class="paletteHolder d-none" id="palette'+userId+'">'+
            //'<select class="palette-dropdown">'+
              //'<option value="1">FMS</option>'+
             // '<option value="2">Virtual Equipment</option>'+
            //'</select>'+
			'<div class="palette-dropdown">FMS</div>'+
            '<div class="palette-drawing">'+
			  '<div class="line-width-hold d-none">'+
                '<div class="line-width-text">2 px</div>'+
                '<input class="line-width-input" type="range" min="1" max="20" value="6" id="canvasLineWidth'+userId+'" />'+
              '</div>'+
              '<span class="canvas-line-icon" id="canvasLine'+userId+'" data-tooltiptext="Straight Line" data-shape-id="0"></span>'+
              '<span class="canvas-joined-icon" id="canvasJoined'+userId+'" data-tooltiptext="Connected Line" data-shape-id="4"></span>'+
              '<span class="canvas-draw-icon" id="canvasFreeHand'+userId+'" data-tooltiptext="Free Form Line" data-shape-id="3"></span>'+
              '<span class="canvas-angle-icon" id="canvasAngle'+userId+'" data-tooltiptext="Protractor" data-shape-id="12"></span>'+
              '<span class="canvas-square-icon" id="canvasSquare'+userId+'" data-tooltiptext="Box" data-shape-id="1"></span>'+
              '<span class="canvas-circle-icon" id="canvasCircle'+userId+'" data-tooltiptext="Circle" data-shape-id="2"></span>'+
              '<span class="canvas-cone-icon d-none" id="canvasSingleCone'+userId+'" data-tooltiptext="Cone" data-shape-id="7"></span>'+
              '<span class="canvas-grid-icon" id="canvasGridSwitch'+userId+'" data-tooltiptext="Show/Hide Grid"></span>'+
              '<span class="canvas-eraser-icon" id="canvasEraser'+userId+'" data-tooltiptext="Eraser" data-shape-id="5"></span>'+
              '<span class="canvas-color-icon" data-tooltiptext="Color"><input type="color" class="color-picker-inside" id="canvasColorPicker'+userId+'" /></span>'+
              '<span class="canvas-screenshot-icon" id="canvasScreenshot'+userId+'" data-tooltiptext="Take A Picture"></span>'+
              '<span class="canvas-gallery-icon" id="canvasGallery'+userId+'" data-tooltiptext="View Pictures">'+
				'<div class="screenshot-dropdown d-none" id="canvasScreenshotDrop'+userId+'"></div>'+
			  '</span>'+
              /* '<span class="canvas-note-icon" id="canvasNote'+userId+'"></span>'+ */
              '<div class="squat-line-text d-none">Squat tolerance <br> (in inches)</div>'+
              '<span class="canvas-trash-icon canvas-squat-icon no-padding d-none" id="canvasSquatLine'+userId+'">'+
                '<select class="canvas-squat-line">'+
                  '<option value="1">1</option>'+
                  '<option value="2" selected="selected">2</option>'+
                  '<option value="3">3</option>'+
                  '<option value="4">4</option>'+
                  '<option value="5">5</option>'+
                  '<option value="6">6</option>'+
                  '<option value="7">7</option>'+
                  '<option value="8">8</option>'+
                  '<option value="9">9</option>'+
                  '<option value="10">10</option>'+
                  '<option value="11">11</option>'+
                  '<option value="12">12</option>'+
                '</select>'+
              '</span>'+
              '<span class="canvas-share share-all-icon" id="canvasShare'+userId+'"></span>'+
              '<span class="canvas-trash-icon btns_canvas" id="canvasClearLines'+userId+'">Clear all</span>'+
              '<span class="canvas-help-icon d-none" id="helpMenu'+userId+'"></span>'+
            '</div>'+
            '<div class="palette-equipment d-none">'+
              '<span class="canvas-ladder-icon d-none" id="canvasLadder'+userId+'" data-shape-id="6"></span>'+
              '<span class="canvas-cone-icon d-none" id="canvasCone'+userId+'" data-tooltiptext="Cone" data-shape-id="7"></span>'+
              '<span class="canvas-box-icon d-none" id="canvasBox'+userId+'" data-shape-id="8"></span>'+
              '<span class="canvas-hurdle-icon d-none" id="canvasHurdle'+userId+'" data-shape-id="9"></span>'+
              '<span class="canvas-bag-icon" id="canvasBag'+userId+'" data-tooltiptext="Punching Bag" data-shape-id="10"></span>'+
              '<span class="canvas-ball-icon d-none" id="canvasBall'+userId+'" data-shape-id="11"></span>'+
              '<span class="canvas-trash-icon btns_canvas" id="canvasClear'+userId+'">Clear all</span>'+
              '<span class="canvas-trash-icon btns_canvas canvas-share" id="canvasShare'+userId+'">Share to all</span>'+
              '<span class="canvas-help-icon d-none" id="helpMenu'+userId+'"></span>'+
            '</div>'+
          '</div>');
  }

  static removeValueFromArray = (streamSelectedArray, userId) => {
      let idIndex = streamSelectedArray.indexOf(userId);
      if ( idIndex > -1 )
      {
        streamSelectedArray.splice(idIndex, 1);
      }
  }

  static calculateAccessDelayMean = (networkStats) => {
      let mean = Util.getMean(networkStats);
      return Math.round(mean);
  }

  static getMean = (data) => {

      var sum = 0;
      let fLen, i;

      fLen = data.length;

      for (i = 0; i < fLen; i++) {
          sum += data[i];
      }

      return sum / fLen;
  }
  
  static getDuration = (data) =>{
  	let ext = data >= 60 ? 'Hr' : 'Min';
      var hours = Math.floor(data / 60);  
      var minutes = data % 60;
      
  	var hDisplay = hours > 0 ? (hours < 10 ? '0'+hours : hours) : "00";
  	var mDisplay = minutes > 0 ? (minutes < 10 ? '0'+minutes : minutes) : "00";
  	return hDisplay + ":" + mDisplay + ' ' + ext;
  }

  static _replaceTag(tag) {
    const REPLACE_TABLE = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;'
    }
    
    return REPLACE_TABLE[tag] || tag;
  }

  static safe_tags_replace(str) {
    return str.replace(/[&<>]/g, Util._replaceTag);
  }

  static getChatTime = (timestamp) => {
      var dt = new Date(timestamp);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var seconds = dt.getSeconds();

      minutes = minutes < 10 ? '0'+minutes : minutes;
      seconds = seconds < 10 ? '0'+seconds : seconds;
      var strTime = hours + ':' + minutes;
      return strTime;
  }

  static getFilenameFromUrl = (url, fullImageName = true) => {
      let imageName = /[^/]*$/.exec(url)[0];

      if (fullImageName) 
      {
          return imageName
      }
      else
      {
          let imageNameLength = imageName.length;

          if (imageNameLength > 15) 
          {
              var extension = imageName.substr( (imageName.lastIndexOf('.') +1) );
              imageName = imageName.substr(0,20) + '...' + extension;
          }

          return imageName;
      }
  }

  static urlify = (text) => {
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
      var hyperlink = url;
      if (!hyperlink.match('^https?:\/\/')) {
        hyperlink = 'http://' + hyperlink;
      }
      return '<a href="' + hyperlink + '" class="chat-link" target="_blank" rel="noopener noreferrer">' + url + '</a>'
    });
  }

  static parseString = (text) => {
    text = Util.urlify(text);
    var urlRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    return text.replace(urlRegex, '<span class="emoji" data-emoji="$&">$&</span>');
  }
}

export default Util;
